<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <slot />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      required: true,
    },
  },
}
</script>
